// find all child updateQuestions of given updateQuestion
export const findAllChildUpdateQuestionIds = (allUpdateQuestions, updateQuestion) => {
    let ids = [];
    updateQuestion.options.forEach( o => {
        o.childQuestions.forEach( cq => {
            const matched = findUpdateQuestionByMachineName( allUpdateQuestions, cq.machineName);
            ids.push(matched.id);
            ids =  [...ids, ...findAllChildUpdateQuestionIds(allUpdateQuestions, matched)]
        });
    });
    return ids;
};


// find the whole tree of the given updateQuestion machine name
export const findUpdateQuestionTree = (allUpdateQuestions, updateQuestion) => {
    if(updateQuestion){
        const subQuestionsIds = findAllChildUpdateQuestionIds(allUpdateQuestions, updateQuestion);
        return allUpdateQuestions.filter(q => (
            subQuestionsIds.includes(q.id)
            || q.id === updateQuestion.id
        ));
    }
};

// find the update form question by machine name
export const findUpdateQuestionByMachineName = (updateQuestions, questionMachineName) => {
    if(!questionMachineName){
        return {};
    }

    return updateQuestions.find( question => {
        return question.machineName.toString() === questionMachineName.toString()
    })
};

// find the update form question by id
export const findUpdateQuestionById = (updateQuestions, questionId) => {
    if(!questionId){
        return {};
    }

    return updateQuestions.find( question => {
        return question.id.toString() === questionId.toString()
    })
};